var map = {
	"./010-name.mp3": 50345,
	"./1.mp3": 85048,
	"./2.mp3": 64006,
	"./3.mp3": 65984,
	"./4.mp3": 18245,
	"./5.mp3": 99426,
	"./6.mp3": 18958,
	"./7.mp3": 88369,
	"./8.mp3": 41615,
	"./9.mp3": 64218
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91243;